export default __webpack_public_path__ + "static/media/teamTopSection.1f437872.svg";